export const MAIN_CONTENT_ID = 'main-content';
export const PROFILE_SWAP_ID = 'swap-profile';
export const PROFILE_NAME_INPUT_ID = 'profile-name-input';
export const PROFILE_CONFLICT_INDICATORS_ID = 'profile-conflict-indicators';
